import { injectable } from "inversify";

export interface CameraService {
    setDefaultCamera(
        mapWidth: number,
        mapHeight: number,
        spriteToFollow: Phaser.Physics.Arcade.Sprite,
        scene: Phaser.Scene
    ): void;

    getCurrentBounds(scene: Phaser.Scene): void;
}

@injectable()
export class DefaultCameraService implements CameraService {
    constructor() {}

    public setDefaultCamera(
        mapWidth: number,
        mapHeight: number,
        spriteToFollow: Phaser.Physics.Arcade.Sprite,
        scene: Phaser.Scene
    ): void {
        // limit camera to map
        scene.cameras.main.setBounds(0, 0, mapWidth, mapHeight);
        scene.cameras.main.startFollow(spriteToFollow);
        scene.cameras.main.roundPixels = true; // avoid tile bleed
    }

    public getCurrentBounds(scene: Phaser.Scene): void {
        // limit camera to map
        //        console.log(scene.cameras.main.getBounds());
    }
}
